import Vue from 'vue'
import Vuex from 'vuex'
import moduleStore from './modules/mainStore'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        requestLoading: false
    },
    mutations: {
        setRequestLoading(state, payload) {
            state.requestLoading = payload;
        }
    },
    actions: {},
    modules: {...moduleStore}
});

export default store;
